import React from "react";
import "../FBOHome.css";
import { Link, useNavigate } from "react-router-dom";
import ROUTE_PATHS from "../../../utils/routePaths";
import { FBO_TYPE } from "../../../utils/constants";
import NavigationBar from "../../../components/element/NavigationBar";
import FBOHeaderBar from "../../../components/element/FBOHeaderBar";
import GridComponent from "../Views/GridComponent";
import invoicingIcon from "../../../assets/images/reports-icon.svg";

const LandLeaseHome = () => {
  const navigate = useNavigate();
  const gridItems = [
    { title: "Invoices", icon: invoicingIcon, width: 23, height: 28 },
  ];

  const handleCardOnClick = () => {
    navigate(ROUTE_PATHS.INVOICES.replace(":aboType", FBO_TYPE.AIRPORT_BASED_OPERATORS));
  };

  return (
    <div>
      <NavigationBar />
      <FBOHeaderBar
        title={"Airport Based Operators - ABOs"}
        backContent={
          <div className="navigation-header">
            <Link to={ROUTE_PATHS.FBO_HOME} className="navigation-header-link">
              Home/
            </Link>
            Airport Based Operators - ABOs
          </div>
        }
      />
      <div className="fee-type-home-container">
        <GridComponent gridItems={gridItems} onClickCard={handleCardOnClick} />
      </div>
    </div>
  );
};

export default LandLeaseHome;
